<template>
  <div class="contact_box" @touchmove.prevent v-if="showType">
    <div class="content">
      <div class="title_top">
        <div class="title">{{pageName.title}}</div>
        <div class="close" @click="close"></div>
      </div>
      <ul class="list_box">
        <li class="item_box">
          <ul class="state">
            <li class="st_list">
              <div class="flag"></div>
              <div class="name">{{pageName.cn}}</div>               
            </li>
          </ul>
          <div class="factory_box">
            <div class="factory" v-if="EVN">
              <p class="name">{{EVN.sname}}</p>
              <p class="text">{{EVN.address}}</p>
              <p class="phone">{{EVN.telephone}}</p>
            </div>
            <div class="factory" v-if="EVH">
              <p class="name">{{EVH.sname}}</p>
              <p class="text">{{EVH.address}}</p>
              <p class="phone mt26">{{EVH.telephone}}</p>
            </div>
          </div>
        </li>
        <li class="item_box">
          <ul class="state">
            <li class="st_list">
              <div class="flag vn"></div>
              <div class="name">{{pageName.vn}}</div>               
            </li>
            <li class="st_list">
              <div class="flag kh"></div>
              <div class="name">{{pageName.kh}}</div>               
            </li>
          </ul>
          <div class="factory_box">
            <div class="factory" v-if="EVM">
              <p class="name">{{EVM.sname}}</p>
              <p class="text">{{EVM.address}}</p>
              <p class="phone">{{EVM.telephone}}</p>
            </div>
            <div class="factory" v-if="EVC">
              <p class="name">{{EVC.sname}}</p>
              <p class="text">{{EVC.address}}</p>
              <p class="phone">{{EVC.telephone}}</p>
            </div>
          </div>
        </li>
        <li class="item_box w166">
          <ul class="state">
            <li class="st_list">
              <div class="flag id"></div>
              <div class="name">{{pageName.id}}</div>               
            </li>
          </ul>
          <div class="factory_box">
            <div class="factory" v-if="PRB">
              <p class="name">{{PRB.sname}}</p>
              <p class="text">{{PRB.address}}</p>
              <p class="phone">{{PRB.telephone}}</p>
            </div>
            <div class="factory" v-if="PBB">
              <p class="name">{{PBB.sname}}</p>
              <p class="text">{{PBB.address}}</p>
              <p class="phone mt26">{{PBB.telephone}}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'myContact',
  props: {
    factoryList: { type: Array, default: () => {} },
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    factoryList: {
      immediate: true,
      handler(arr) {
        this.init();
      },
    },
    LangIndex: {
      handler(str) {
        this.initLang();
      },
    },
  },
  data() {
    return {
      showType: false,
      EVN: '',
      EVH: '',
      EVM: '',
      EVC: '',
      PRB: '',
      PBB: '',
      pageName: '',
      pageName_cn: {
        title: '联系我们',
        cn: '中国',
        vn: '越南',
        kh: '柬埔寨',
        id: '印尼',
      },
      pageName_en: {
        title: 'Contact Us',
        cn: 'CN',
        vn: 'VN',
        kh: 'KH',
        id: 'ID',
      },
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.EVN = this.even(this.factoryList, 'EVN')[0];
      this.EVH = this.even(this.factoryList, 'EVH')[0];
      this.EVM = this.even(this.factoryList, 'EVM')[0];
      this.EVC = this.even(this.factoryList, 'EVC')[0];
      this.PRB = this.even(this.factoryList, 'PRB')[0];
      this.PBB = this.even(this.factoryList, 'PBB')[0];
      this.initLang();
    },
    initLang() {
      if (this.LangIndex === 1) {
        this.pageName = this.pageName_cn;
      } else {
        this.pageName = this.pageName_en;
      };
    },
    // 数据过滤
    even(numbers, target) {
      return numbers.filter(function (number) {
        return number.sname === target
      })
    },
    show() {
      this.showType = true;
    },
    close() {
      this.showType = false;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.contact_box{
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  .content{
    width: 628px;
    padding: 44px;
    background-color: #fff;
    border: 1px solid #eee;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9;
    .title_top{
      width: 100%;
      height: 32px;
      line-height: 32px;
      overflow: hidden;
      .title{
        float: left;
        font-size: 36px;
        color: #272727;
      }
      .close{
        float: right;
        width: 32px;
        height: 32px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../../assets/icon/us_03.png);
        background-size: 32px 32px;
        cursor: pointer; 
      } 
    }
    .list_box{
      display: block;
      width: 100%;
      margin-top: 38px;
      overflow: hidden;
      .item_box{
        width: 195px;
        padding-right: 28px;
        color: #272727;
        float: left;
        &.w166{
          width: 166px;
        }
        .state{
          width: 100%;
          overflow: hidden;
          .st_list{
            width: 70px;
            float: left;
            .flag{
              width: 40px;
              height: 27px;
              background-position: center;
              background-repeat: no-repeat;
              background-image: url(../../assets/icon/us_07.png);
              background-size: 40px 27px;
              &.vn{
                background-image: url(../../assets/icon/us_09.png);
                background-size: 40px 27px;                
              }
              &.kh{
                background-image: url(../../assets/icon/us_11.png);
                background-size: 40px 27px;                
              }
              &.id{
                background-image: url(../../assets/icon/us_13.png);
                background-size: 40px 27px;                
              }                 
            }
            .name{
              width: 100%;
              height: 30px;
              line-height: 30px;
              font-size: 20px;
              margin-top: 10px;
              overflow: hidden;
            }
          }
        }
        .factory_box{
          width: 100%;
          border-right: 1px solid #e4e4e4;
        }
        .factory{
          width: 100%;
          margin-top: 15px;
          overflow: hidden;
          .name{
            width: 100%;
            height: 22px;
            line-height: 22px;
            font-size: 16px;
          }
          .text{
            width: 100%;
            font-size: 14px;
            line-height: 16px;
          }
          .phone{
            width: 184px;
            font-size: 14px;
            line-height: 16px;
            margin-top: 10px;
            &.mt26{
              margin-top: 26px;
            }     
          }
        }
      }
      .item_box:last-child{
        padding-right: 0;
        .factory_box{
          border: none;
        }
      }
    }

  }
}
</style>
